import { linklistApi } from '@/utils/axios-config';
import { use } from 'vuedraggable';

export default {
    create(name) {
        return linklistApi.post(`/organisations/`, {
            name,
        });
    },
    delete(organisation_slug) {
        return linklistApi.delete(`/organisations/${organisation_slug}/`);
    },
    get(organisation_slug) {
        return linklistApi.get(`/organisations/${organisation_slug}/`);
    },
    update(organisation_slug, data) {
        return linklistApi.put(`/organisations/${organisation_slug}/`, data);
    },
    addFont(organisation_slug, data) {
        return linklistApi.post(
            `/organisations/${organisation_slug}/font`,
            data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        );
    },
    users(organisation_slug) {
        return linklistApi.get(
            `/organisations/${organisation_slug}/settings/users`,
        );
    },
    pendingInvites(organisation_slug) {
        return linklistApi.get(
            `/organisations/${organisation_slug}/settings/users/invites`,
        );
    },
    invite(organisation_slug, data) {
        return linklistApi.post(
            `/organisations/${organisation_slug}/settings/users/invites`,
            data,
        );
    },
    deleteInvitation(organisation_slug, invitation_id) {
        return linklistApi.delete(
            `/organisations/${organisation_slug}/settings/users/invites/${invitation_id}`,
        );
    },
    deleteUser(organisation_slug, user_id) {
        return linklistApi.delete(
            `/organisations/${organisation_slug}/settings/users/${user_id}`,
        );
    },
};
